import { render, staticRenderFns } from "./FailureLogsDatatable.vue?vue&type=template&id=4d7fe37a&scoped=true"
import script from "./FailureLogsDatatable.vue?vue&type=script&lang=js"
export * from "./FailureLogsDatatable.vue?vue&type=script&lang=js"
import style0 from "./FailureLogsDatatable.vue?vue&type=style&index=0&id=4d7fe37a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7fe37a",
  null
  
)

export default component.exports